import { render, staticRenderFns } from "./MechanicsList.vue?vue&type=template&id=3b85e21c&"
import script from "./MechanicsList.vue?vue&type=script&lang=js&"
export * from "./MechanicsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports